import React from 'react';
import icon from '../../../../assets/dbs/db_eg.png';

const EgIcon = () => (
    <div>
        <img style = {{height: 25, paddingBottom:5, paddingRight: 5}} src={icon} alt="eg"/>
    </div>
);
export default EgIcon;